import React from "react";
import styles from "./InputTypeComponent.module.scss";

interface InputTypeComponentProps {
  label: string;
  value?: any;
  placeholder?: string;
  className?: string;
  onClick?: () => void;
  iconName?: string;
  iconWrapperClass?: string;
}

const InputTypeComponent: React.FC<any> = (props: InputTypeComponentProps) => {
  const { label, value, placeholder = "", className, onClick, iconName, iconWrapperClass } = props;

  return (
    <div className={`${styles.fieldWrapper} ${className}`}>
      <label className={styles.fieldLabel}>{label}</label>
      <div onClick={onClick}>
        <div className={`${styles.fieldInput} ${className || ""}`}>{value ? value : placeholder}</div>
        {iconName && (
          <div className={`${styles.postFix} ${iconWrapperClass}`}>
            <span className={iconName} />
          </div>
        )}
      </div>
    </div>
  );
};

export default InputTypeComponent;
